/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseDevise } from '../models/api-response-devise';
import { ApiResponseListDevise } from '../models/api-response-list-devise';
import { ApiResponsePagedResultDevise } from '../models/api-response-paged-result-devise';
import { ApiResponseVoid } from '../models/api-response-void';
import { createDevise } from '../fn/devise-api/create-devise';
import { CreateDevise$Params } from '../fn/devise-api/create-devise';
import { deleteDeviseByRef } from '../fn/devise-api/delete-devise-by-ref';
import { DeleteDeviseByRef$Params } from '../fn/devise-api/delete-devise-by-ref';
import { getDeviseByRef } from '../fn/devise-api/get-devise-by-ref';
import { GetDeviseByRef$Params } from '../fn/devise-api/get-devise-by-ref';
import { listDevis } from '../fn/devise-api/list-devis';
import { ListDevis$Params } from '../fn/devise-api/list-devis';
import { patchDeviseArchiveStatus } from '../fn/devise-api/patch-devise-archive-status';
import { PatchDeviseArchiveStatus$Params } from '../fn/devise-api/patch-devise-archive-status';
import { searchDevise } from '../fn/devise-api/search-devise';
import { SearchDevise$Params } from '../fn/devise-api/search-devise';
import { updateDevise } from '../fn/devise-api/update-devise';
import { UpdateDevise$Params } from '../fn/devise-api/update-devise';

@Injectable({ providedIn: 'root' })
export class DeviseApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDeviseByRef()` */
  static readonly GetDeviseByRefPath = '/v1/api/ui/devise/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeviseByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeviseByRef$Response(params: GetDeviseByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDevise>> {
    return getDeviseByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDeviseByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeviseByRef(params: GetDeviseByRef$Params, context?: HttpContext): Observable<ApiResponseDevise> {
    return this.getDeviseByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseDevise>): ApiResponseDevise => r.body)
    );
  }

  /** Path part for operation `updateDevise()` */
  static readonly UpdateDevisePath = '/v1/api/ui/devise/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDevise()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDevise$Response(params: UpdateDevise$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDevise>> {
    return updateDevise(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDevise$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDevise(params: UpdateDevise$Params, context?: HttpContext): Observable<ApiResponseDevise> {
    return this.updateDevise$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseDevise>): ApiResponseDevise => r.body)
    );
  }

  /** Path part for operation `deleteDeviseByRef()` */
  static readonly DeleteDeviseByRefPath = '/v1/api/ui/devise/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDeviseByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDeviseByRef$Response(params: DeleteDeviseByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVoid>> {
    return deleteDeviseByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteDeviseByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDeviseByRef(params: DeleteDeviseByRef$Params, context?: HttpContext): Observable<ApiResponseVoid> {
    return this.deleteDeviseByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseVoid>): ApiResponseVoid => r.body)
    );
  }

  /** Path part for operation `patchDeviseArchiveStatus()` */
  static readonly PatchDeviseArchiveStatusPath = '/v1/api/ui/devise/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchDeviseArchiveStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchDeviseArchiveStatus$Response(params: PatchDeviseArchiveStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchDeviseArchiveStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchDeviseArchiveStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchDeviseArchiveStatus(params: PatchDeviseArchiveStatus$Params, context?: HttpContext): Observable<void> {
    return this.patchDeviseArchiveStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createDevise()` */
  static readonly CreateDevisePath = '/v1/api/ui/devise';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDevise()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDevise$Response(params: CreateDevise$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDevise>> {
    return createDevise(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createDevise$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDevise(params: CreateDevise$Params, context?: HttpContext): Observable<ApiResponseDevise> {
    return this.createDevise$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseDevise>): ApiResponseDevise => r.body)
    );
  }

  /** Path part for operation `searchDevise()` */
  static readonly SearchDevisePath = '/v1/api/ui/devise/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchDevise()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchDevise$Response(params: SearchDevise$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultDevise>> {
    return searchDevise(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchDevise$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchDevise(params: SearchDevise$Params, context?: HttpContext): Observable<ApiResponsePagedResultDevise> {
    return this.searchDevise$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultDevise>): ApiResponsePagedResultDevise => r.body)
    );
  }

  /** Path part for operation `listDevis()` */
  static readonly ListDevisPath = '/v1/api/ui/devise/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listDevis()` instead.
   *
   * This method doesn't expect any request body.
   */
  listDevis$Response(params: ListDevis$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListDevise>> {
    return listDevis(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listDevis$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listDevis(params: ListDevis$Params, context?: HttpContext): Observable<ApiResponseListDevise> {
    return this.listDevis$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListDevise>): ApiResponseListDevise => r.body)
    );
  }

}
